<template>
	<div class="channelShopCell">
		<div class="flex flex-align-center">
			<img class="shop_img" :src="row.productPic" alt="" />
			<div class="box ml-10 PingFang yx-color-text-primary fz-13">
				<p class="title ellipsis">
					<platform-icon :platformId="row['platformId']"></platform-icon>
					{{ row.productName }}
				</p>
				<p class="title ellipsis">ID: {{ row.productId }}</p>

				<div class="flex flex-align-center">
					<span class="product-tag mr-6" v-if="row['productTypeDesc']">{{ row.productTypeDesc }}</span>
					<span class="brand-name pr-4 pl-4 pt-2 pb-2" v-if="row['brandName']">{{ row['brandName'] }}</span>
					<span class="ml-6 cate_name pr-4 pl-4 pt-2 pb-2" v-if="row['rootCateName']">{{ row['rootCateName'] }}</span>
				</div>
				<div class="flex flex-align-center font-h6-regular yx-color-text-p-4">
					<span>店铺：</span>
					<span>{{ row.shopName }}</span>
					<el-tooltip class="item" effect="dark" placement="top">
						<div slot="content" class="content">
							<span>店铺ID</span>
							<span class="ml-10">{{ row.shopId }}</span>
							<img src="@/assets/public/copy-icon.png" alt="" @click="copy(row.shopId)" />
						</div>
						<span class="ID-sign yx-color-primary nowrap">ID</span>
					</el-tooltip>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin.js';
export default {
	data() {
		return {};
	},
	mixins: [mixin],
	methods: {
		copy(value) {
			var inputTest = document.createElement('textarea');
			inputTest.value = value;
			document.body.appendChild(inputTest);
			inputTest.select();
			document.execCommand('Copy');
			inputTest.className = 'oInput';
			inputTest.style.display = 'none';
			this.$message.success('复制成功');
			document.body.removeChild(inputTest);
		},
	},
};
</script>
<style lang="less" scoped>
.title {
	max-width: 300px;
}
.ellipsis {
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
.category {
	width: 150px;
}
.shop_img {
	width: 40px;
	height: 40px;
	border-radius: 5px;
}
.ID-sign {
	padding: 0px 4px;
	border-radius: 2px;
	margin-left: 3px;
	background-color: @color-parachrome;
	cursor: default;
}
.brand-name {
	color: #ae6c41;
	background-color: #fff2e9;
	border-radius: 2px;
	font-weight: 500;
}
.cate_name {
	background-color: #f8f8f8;
	color: #666666;
}
.product-tag {
	color: @color-primary;
	background-color: #ebf2fd;
}
.content {
	display: flex;
	align-items: center;
	img {
		margin-left: 8px;
		width: 16px;
		height: 16px;
		cursor: pointer;
	}
}
</style>
